import { alkymetricsClient } from '../alkymetricsClient';

export const getOnboardingStatus = async (workspaceId) => {
  try {
    const { data } = await alkymetricsClient.get(
      `/partner-to-workspace/onboarding-status/${workspaceId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};
